import {FormSinistreModel} from './FormSinistreModel';
import {FormAlcoolemieModel} from './FormAlcoolemieModel';
import {FormStupefiantModel} from './FormStupefiantModel';

export class FormAntecedentsModel {
  isEteAssure36DerniersMois: string;
  isAssure36DerniersMoisAvec9MoisConsecutifs: string;
  bonusMalus: string;
  nbrAnneeBonusCinquante: number;
  periodeAssure36DerniersMois: number;
  isEteResilie36DerniersMois = 0;
  motifResiliation36DerniersMois: string;
  dureeNonPaiement: number;
  nombreAssureursResiliationNonPaiement: string;
  recidiveResiliationNonPaiement: string;
  contentieuxSoldeResiliationNonPaiement: string;
  dateResiliation36DerniersMois: string;
  isEuSinistres36DerniersMois: string;
  sinistres36DerniersMois: FormSinistreModel[];
  isEuAlcoolemie36DerniersMois: string;
  alcoolemie: FormAlcoolemieModel;
  // nombreControlesPositifsAlcoolemie36DerniersMois: number;
  // dateDernierAlcoolemie36DerniersMois: string;
  // controleAlcoolemieSuiteA36DerniersMois: string;
  // controleAlcoolemieMethode36DerniersMois: string;
  // isRefusTestAlcoolemie36DerniersMois: string;
  // tauxAlcoolemie: number;
  // isDelitDeFuiteAlcoolemie36DerniersMois: string;
  isEuStupefiant36DerniersMois: string;
  stupefiant: FormStupefiantModel;
  // nombreControlesPositifsStupefiants36DerniersMois: number;
  // dateDernierStupefiant36DerniersMois: string;
  // controleStupefiantSuiteA36DerniersMois: string;
  // controleStupefiantMethode36DerniersMois: string;
  // isRefusTestStupefiant36DerniersMois: string;
  // isDelitDeFuiteStupefiant36DerniersMois: string;
  // isAnnulationOuSuspensionPermis36DerniersMois: string;
  // typeAnnulationPermis36DerniersMois: string;
  // typeSuspensionPermis36DerniersMois: string;
  // annulationPermisAvecOuSansSinistre36DerniersMois: string;
  // annulationPermisMotif36DerniersMois: string;
  // dateAnnulationPermis36DerniersMois: string;
  // suspensionPermisMotif36DerniersMois: string;
  // dateSuspensionPermis36DerniersMois: string;
  // dateInfraction36DerniersMois: string;
  // dateSanction36DerniersMois: string;
  // dureeSanction36DerniersMois: number;
  // nombreSuspensionPermis36AvecSinistreDerniersMois: number;
  // nombreSuspensionPermis36SansSinistreDerniersMois: number;
  // nombreMoisSuspensionPermis36DerniersMois: number;
  constructor() {
    this.alcoolemie = new FormAlcoolemieModel();
    this.stupefiant = new FormStupefiantModel();
  }
}
